import React from "react";
import CommonFunctions from "../commonFunctions.js";
import { Form, Select, Button, FormGroup,Col,Row,InputGroup, FormControl, ControlLabel } from "react-bootstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs";

class Tax extends CommonFunctions {
  constructor(props) {
    super(props)
    this.state = {
      validated: 0,
      breadcrum_params: [],
      name :'',
      percentage :'',
    }
    this.errors = [];
    this.handleSubmit  = this.handleSubmit.bind(this);
  }
  
  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();    
    this.setState({ validated: this.state.validated + 1 })
    
    if(form.checkValidity() === true)
    {
      const url = "tax/"+this.props.match.params.slug;
      const params = {name: this.state.name, percentage : this.state.percentage}
      this.apiCall(url, params, "../taxes", "PUT", "Tax Details added")
    }
  }
  
  componentDidMount() {
    var newBreadcrum = this.state.breadcrum_params.slice();
    newBreadcrum.push([1,'../taxes', 'Tax']);
    newBreadcrum.push([0, 0, 'Update Tax']);
    this.setState({breadcrum_params: newBreadcrum});  

    let url = "tax/"+this.props.match.params.slug;
    let params = {};
    this.apiCall(url, params, '', 'GET','').then(res => {
        this.setState({name: res.data[0].name, percentage: res.data[0].percentage,slug: res.data[0].slug}); 
    })

  }

  render() {
    const {breadcrum_params} = this.state;
    const {taxes} = this.state;
    return (
      <div>
      <Breadcrumbs params = {breadcrum_params}/> 

    <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
      <h3>Update Tax Details</h3>
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="id01">
          <Form.Label>Tax Name<span className="text-danger"> *</span></Form.Label>
          <Form.Control 
            type="text" 
            name="name"
            placeholder="Enter tax name" 
            required
            value={this.state.name} 
            onChange={this.validateInput}
            isInvalid={this.errors.name}
            autoFocus
            autoComplete='off'
            />
          <Form.Control.Feedback type="invalid">
            {this.errors.name ? this.errors.name : 'Please provide tax name'}
          </Form.Control.Feedback>
        </Form.Group>
        </Row>

        <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="id02">
          <Form.Label>Tax Percentage<span className="text-danger"> *</span></Form.Label>
          <Form.Control 
            type="number" 
            name="percentage"
            placeholder="Enter tax percentage" 
            required
            value={this.state.percentage} 
            onChange={this.validateInput}
            isInvalid={this.errors.percentage}
            autoFocus
            autoComplete='off'
            min="1"
            />
          <Form.Control.Feedback type="invalid">
            {this.errors.percentage ? this.errors.percentage : 'Please provide tax percentage'}
          </Form.Control.Feedback>
        </Form.Group>
        </Row>

      <Button type="submit">Save</Button> &nbsp;
      <Button variant="secondary" onClick={this.goBack}>Cancel</Button>
    </Form>
    </div>
  );
}
}

export default Tax;